function Toiawase() {
  return (
    <div className="toiawase section">
      <h2 className="title">
        <img src="images/yodogawa-1.png" alt="お問い合わせ" />
      </h2>

      <p className="emp">090-1708-6701</p>
      <p className="hosoku">
        yodogawakouza@mydomind.com
        <br />
        （担当：山本）
      </p>
      <div className="art-1">
        <img src="images/art-3.png" alt="" />
      </div>
      <div className="art-2">
        <img src="images/art-2.png" alt="" />
      </div>
    </div>
  );
}

export default Toiawase;
